// Hook listy komentarzy do oferty (nagłówka).
// GET /sales-crm/clients/:cid/offers/:oid/comments

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  ISalesCrmOfferPositionComment,
  SalesCrmCommentAuthorType
} from 'api/endpoints/useGetSalesCrmOfferPositionComments';

/** Element listy komentarzy do oferty (nagłówka). Współdzieli kształt z komentarzem pozycji. */
export type ISalesCrmOfferComment = ISalesCrmOfferPositionComment;

export type { SalesCrmCommentAuthorType };

export interface ISalesCrmOfferCommentsResponse {
  items: ISalesCrmOfferComment[];
}

export const getSalesCrmOfferCommentsQueryKey = (
  clientId: number,
  offerId: string,
  versionId?: number | null
) =>
  ['sales-crm', 'client', clientId, 'offer', offerId, 'comments', versionId ?? 'actual'] as const;

const getSalesCrmOfferComments = (
  clientId: number,
  offerId: string,
  versionId?: number | null
): Promise<ISalesCrmOfferCommentsResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}/comments`, {
    params: versionId ? { versionId } : undefined
  });

export const useGetSalesCrmOfferComments = (
  clientId: number,
  offerId: string,
  versionId?: number | null,
  options?: UseQueryOptions<ISalesCrmOfferCommentsResponse, IError>
) =>
  useQuery<ISalesCrmOfferCommentsResponse, IError>(
    getSalesCrmOfferCommentsQueryKey(clientId, offerId, versionId),
    () => getSalesCrmOfferComments(clientId, offerId, versionId),
    {
      ...options,
      enabled: options?.enabled !== false && clientId > 0 && String(offerId).trim().length > 0
    }
  );
